<template>
    <div class="card team-card">
        <div class="card-body">
            <div class="head">
                <strong class="name">
                    {{ team.name }}
                </strong>
<!--                <div class="actions">-->
<!--                    <a href="#" @click.prevent.stop="showSettings()">-->
<!--                        <img class="mr-1"-->
<!--                             src="/images/icons/cog.svg"-->
<!--                             alt="">-->
<!--                    </a>-->
<!--                </div>-->
            </div>

            <div class="members py-1">
                <a v-for="member in team.members"
                   href="#"
                   @click.prevent.stop=""
                   class="member">
                    <name-icon :value="member"/>
                </a>
            </div>

        </div>

        <div class="card-footer d-flex justify-content-between">
            <inertia-link :href="route('project.canvas.show', {project: team.pivot.project_id, team: team.id, ...global_url_params})"
                          class="btn btn-sm btn-primary">Canvas</inertia-link>
        </div>

        <team-settings-modal v-if="settings_visible"
                             :team="team"
                             @close="hideSettings()"/>

    </div>
</template>

<script>
import utils from "@/mixins/utils";
import useClipboard from 'vue-clipboard3';
import NameIcon from "@/Components/Team/NameIcon";
import TeamSettingsModal from "@/Components/Team/TeamSettingsModal";
const { toClipboard } = useClipboard();

export default {
    name: "TeamCard",
    components: {TeamSettingsModal, NameIcon},
    props: ['team', 'canvas'],
    mixins: [ utils ],

    data(){
        return {
            settings_visible: false,
        }
    },


    computed: {
        uuid(){
            return this.canvas.uuid.toUpperCase();
        },

        uuid_partial(){
            return this.uuid.substr(0, 10);
        },
    },

    methods: {
        showSettings(){
            console.log('show settings');
            this.settings_visible = true;
        },

        hideSettings(){
            this.settings_visible = false;
        },

        name(member){
            return typeof member.display_name !== 'undefined' ? member.display_name : member.name;
        },
        async copy(text){
            await toClipboard(text);
        }
    }

}
</script>

<style lang="scss" scoped>
.head{
    display: flex;
    justify-content: space-between;
}
.card-body, .card-footer{
    padding: 0.6rem 0.8rem;
    overflow: hidden;
}
.members{
    display: flex;
    margin-left: 8px;

    .member{
        margin-left: -8px;
        text-decoration: none;
    }

    .add-member{
        color: white;
        padding: 0.4rem;
        width: 36px;
        height: 36px;
        margin-left: -8px;
        border-radius: 50%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: $font-weight-bold;
        border: white solid 2px;
        box-shadow: $box-shadow-sm;
        text-decoration: none;
    }

    .add-member{
        background: #20CE83;
        margin-left: auto;
    }
}
</style>
